import React from 'react'
import Section from '../Section'
import ExperienceUnit from '../ExperienceUnit'

import zomatoLogo from '../../assets/images/experience/demo.png'


class ExperienceSection extends React.Component {
  render() {
    return (
      <Section title="Experience">
        <div className="row">
          <ExperienceUnit
            logo={zomatoLogo}
            colour='#CB202D'
            title='Website'
            link='https://www.deepakmishra.com/'
            timeperiod='2014 - 2015'
            subtitle='New Website'
          />
        </div>
      </Section>
    )
  }
}

export default ExperienceSection



// WEBPACK FOOTER //
// ./src/components/ExperienceSection/index.js